<template>
  <div>
      <!-- Pastille d'information -->
      <div class="row">
        
              <!-- ================================================================= -->
              <!-- Section d'affichage des transactions des abonnements de l'organisation -->
              <!-- ================================================================= -->
            <div class="col-sm-12 col-md-12">
              <div class="block block-themed block-bordered">
                <div class="block-header bg-primary-dark">
                      <ul class="block-options">
                          <li v-if="flagDisplaySectionTransactions===0">
                              <button type="button" @click="toggleDisplayTransactions()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                          </li>
                          <li v-if="flagDisplaySectionTransactions">
                              <button  type="button" @click="toggleDisplayTransactions()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                          </li>
                      </ul>
                  <h2 class="block-title" @click="toggleDisplayTransactions()">{{ sectionLabelTransactions[actualLanguage] }}</h2>
                </div>

                <div v-if="flagDisplaySectionTransactions" class="block-content">
                    
                      <div v-for ="(transaction,index) in transactions" class="block block-bordered">
                        <div class="block-header bg-gray-lighter">
                            <ul class="block-options">
                                <li>
                                    <button type="button" @click="toggleDisplayTransaction(index)"><i class="fa fa-dollar"></i></button>
                                </li>
                            </ul>
                            <h3 class="block-title" @click="toggleDisplayTransaction(index)">{{transaction.subscription}}:{{transaction.timestamp}}</h3>
                        </div>
                        <div v-if="transactionOpenFlag[index]" class="block-content">

                            <div class="table-responsive push-50">
                                <table class="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="width: 50px;"></th>
                                            <th>{{textLabelProduct[[actualLanguage]]}}</th>
                                            <th class="text-center" style="width: 100px;">{{InvoiceQuantity[actualLanguage]}}</th>
                                            <th class="text-right" style="width: 120px;">{{InvoiceUnitPrice[actualLanguage]}}</th>
                                            <th class="text-right" style="width: 120px;">{{InvoicePrice[actualLanguage]}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for ="(transactionLine,index) in transaction.detailLines">
                                            <td class="text-center">{{index+1}}</td>
                                            <td>
                                                <p class="font-w600 push-10">{{transactionLine.description[actualLanguage]}}</p>
                                            </td>
                                            <td class="text-center"><span class="badge badge-primary">{{transactionLine.quantity}}</span></td>
                                            <td class="text-right">$ {{transactionLine.unitPrice}}</td>
                                            <td class="text-right">$ {{transactionLine.unitPrice*transactionLine.quantity}}</td>
                                        </tr>


                                        <tr>
                                            <td colspan="4" class="font-w600 text-right">{{InvoiceSubTotal[actualLanguage]}}</td>
                                            <td class="text-right">$ {{transaction.subTotal}}</td>
                                        </tr>
                                        <tr v-if="transaction.tps > 0">
                                            <td colspan="4" class="font-w600 text-right">TPS (5%)</td>
                                            <td class="text-right">$ {{transaction.tps}}</td>
                                        </tr>
                                        <tr v-if="transaction.tvq > 0">
                                            <td colspan="4" class="font-w600 text-right">TVQ (9.975%)</td>
                                            <td class="text-right">$ {{transaction.tvq}}</td>
                                        </tr>

                                        <tr v-for="(taxLine, index2) in transaction.taxesList">
                                            <td colspan="4" class="font-w600 text-right">{{taxLine.Label[actualLanguage]}}</td>
                                            <td class="text-right">$ {{taxLine.Amount}}</td>
                                        </tr>

                                        <tr class="active">
                                            <td colspan="4" class="font-w700 text-uppercase text-right">Total</td>
                                            <td class="font-w700 text-right">$ {{transaction.total}}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div >
                                    <h6 class="block-title text-left" >{{CardInfoPaidBy[actualLanguage]}}{{transaction.cardData.CardType}}</h6>
                                    <h6 class="block-title text-left" >{{CardInfoLast4[actualLanguage]}}{{transaction.cardData.CardLast4}}</h6>
                                </div>
                                <div class="col-sm-6 col-lg-6 align-right">
                                  <button @click="generatePdfInvoice(index)" class="btn btn-md btn-success align-right" type="button" title="Download PDF"><i class="fa fa-download"></i> Download PDF Invoice</button>
                                </div>
                            </div>

                        </div>
                      </div>
                
                </div>
              </div>

        </div>
    </div>

  </div>
</template>

<script>

import _ from 'underscore'
import { mapState, mapActions } from 'vuex'

//See:https://codingshiksha.com/vue/vue-js-pdf-generator-in-vuetify-ui-using-jspdf-and-jspdf-autotable-library-full-tutorial-for-beginners/
import jsPDF from 'jspdf'


export default {
  props: ['organizationData'],

  components: {
   },


  data() {
    return {
      
      actualLanguage : "FR",
      labelFreeService: {FR: 'Service gratuit', EN: 'Free service'},
      automaticRenewFlagInititalValue : false,
      renewFlagModified : false,

      textLabelProduct:{FR: "Produit", EN: 'Product'},
      textLabelLastPaimentDate:{FR: "Date du précédent prélèvement : ", EN: 'Previous payment date:'},
      textLabelNextPaimentDate:{FR: "Date du prochain prélèvement : ", EN: 'Next payment date:'},
      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},


      sectionLabelTransactions:{FR: "Historique de paiement", EN: 'Payment history'},
      flagDisplaySectionTransactions : 0,
      transactions : [],
      transactionOpenFlag : [],

      InvoiceText: {FR: "Facture: ", EN: 'Invoice: '},
      InvoiceTitle: {FR: "SERVICE PLATEFORME ADMINISTRATEUR", EN: 'MANAGER PLATFORM CHARGE'},
      InvoiceCustomer: {FR: "CLIENT: ", EN: 'CUSTOMER: '},
      InvoicePaidBy: {FR: "PAYÉ AVEC: ", EN: 'PAID BY: '},
      InvoiceQuantity: {FR: "Quantité", EN: 'Quantity'},
      InvoiceUnitPrice: {FR: "Prix unitaire", EN: 'Unit price'},
      InvoicePrice: {FR: "Prix", EN: 'Price'},
      InvoiceSubTotal: {FR: "Sous total", EN: 'Sub total'},
      CardInfoPaidBy: {FR: "Payé par:", EN: 'Paid by:'},
      CardInfoLast4: {FR: "Finissant par:", EN: 'Last digits:'},



    }
  },

  computed: {
    ...mapState('sessionStore', ['planTransactionData']),
    ...mapState('sessionStore', ['userEmail','profileData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

    toggleDisplayTransactions(){
      this.flagDisplaySectionTransactions=~this.flagDisplaySectionTransactions
    },
    toggleDisplayTransaction(index){
      this.flagDisplaySectionTransactions=0
      this.transactionOpenFlag[index]=~this.transactionOpenFlag[index]
      this.flagDisplaySectionTransactions=-1
    },

    automaticRenewButtonSwitch(){
      if(this.organizationData.subscription.data.automaticRenewFlag == this.automaticRenewFlagInititalValue){
          this.renewFlagModified = true
      }else{
          this.renewFlagModified = false
      }
    },
      

    getTransactionHistory(){
      
      var requestData = { 'postAction':'ReadOrganizationTransactionHistory',
                          'organizationId':this.organizationData.organizationId,
                          }

      this.$store.dispatch('sessionStore/postOrganization', requestData)
        .then((response) => {
          if(response.data.Code=='OK'){
           //console.log('transaction history')
            //console.log(response.data)
            this.transactions = response.data.TransactionHistory
            this.transactionOpenFlag = []
            for(var m = 0;m < this.transactions.length;m++){
              this.transactionOpenFlag.push(0)
              if(parseFloat(this.transactions[m].subTotal) < 0){this.transactions[m].subTotal = "0"}
              if(parseFloat(this.transactions[m].tps) < 0){this.transactions[m].tps = "0"}
              if(parseFloat(this.transactions[m].tvq) < 0){this.transactions[m].tvq = "0"}
              if(parseFloat(this.transactions[m].total) < 0){this.transactions[m].total = "0"}

              for(var n = 0;n < this.transactions[m].taxesList.length;n++){
                if(parseFloat(this.transactions[m].taxesList[n].Amount) < 0){this.transactions[m].taxesList[n].Amount = "0"}
                }
              
              }
            }
            else{
              console.log(response)
               window.alert(response.data.PromptMessage[this.actualLanguage] )
            }
        })
    },

    generatePdfInvoice(index){
      //console.log('OrganizationData')
      //console.log(this.organizationData)


      const columns = [
        { title: "Title", dataKey: "title" },
        { title: "Body", dataKey: "body" }
      ];
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "in",
        format: "letter"
      });

      // Header
      doc.setFontSize(10).text(this.InvoiceText[this.actualLanguage]+this.transactions[index].subscription+':'+this.transactions[index].timestamp, 0.5, 1.0);
      doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1);
      doc.setFontSize(14).text('EV Sens inc.', 8, 1.3,{ align: "right"});
      doc.setFontSize(10).text('65 rue de la Fenière', 8, 1.5,{ align: "right"});
      doc.setFontSize(10).text("L'Ancienne-Lorette, QC", 8, 1.7,{ align: "right"});
      doc.setFontSize(10).text("CANADA, G2E 1X8", 8, 1.9,{ align: "right"});
      doc.setFontSize(10).text("support@evsens.ca", 8, 2.1,{ align: "right"});

      // Title
      doc.setLineWidth(0.01).line(0.5, 2.2, 8.0, 2.2);
      doc.setFontSize(16).text(this.InvoiceTitle[this.actualLanguage], 4.25, 2.5,{ align: "center",maxWidth: "7.5" });
      doc.setLineWidth(0.01).line(0.5, 2.7, 8.0, 2.7);

      // Customer description
      doc.setFontSize(12).text(this.InvoiceCustomer[this.actualLanguage], 0.5, 3,{ align: "left",maxWidth: "7.5" });
      doc.setFontSize(12).text(this.organizationData.organizationInfo.name, 0.5, 3.2,{ align: "left",maxWidth: "7.5" });
      doc.setFontSize(10).text(this.organizationData.organizationInfo.address, 0.5, 3.4,{ align: "left",maxWidth: "7.5" });
      doc.setFontSize(10).text(this.organizationData.organizationInfo.city+', '+this.organizationData.organizationInfo.province, 0.5, 3.6,{ align: "left",maxWidth: "7.5" });
      doc.setFontSize(10).text(this.organizationData.organizationInfo.country+', '+this.organizationData.organizationInfo.postalCode, 0.5, 3.8,{ align: "left",maxWidth: "7.5" });
      

      //Invoice description
      doc.setFontSize(10).text("Quantity", 0.5, 4.2,{ align: "left",maxWidth: "7.5" });
      doc.setFontSize(10).text("Description", 1.5, 4.2,{ align: "left",maxWidth: "3" });
      doc.setFontSize(10).text("Unit Price ($)", 6.5, 4.2,{ align: "right",maxWidth: "7.5" });
      doc.setFontSize(10).text("Cost ($)", 7.5, 4.2,{ align: "right",maxWidth: "7.5" });
      doc.setLineWidth(0.01).line(0.5, 4.3, 8.0, 4.3);

      var y_pos = 0
      var lineCost = 0
      for (var n = 0; n < this.transactions[index].detailLines.length; n++) {
        y_pos =  4.5+n*0.2
        lineCost = this.transactions[index].detailLines[n].unitPrice * this.transactions[index].detailLines[n].quantity
        doc.setFontSize(10).text(this.transactions[index].detailLines[n].quantity, 0.5, y_pos,{ align: "left",maxWidth: "7.5" });
        doc.setFontSize(10).text(this.transactions[index].detailLines[n].description[this.actualLanguage], 1.5, y_pos,{ align: "left",maxWidth: "3" });
        doc.setFontSize(10).text(this.transactions[index].detailLines[n].unitPrice, 6.5, y_pos,{ align: "right",maxWidth: "7.5" });
        doc.setFontSize(10).text(lineCost.toString(), 7.5, y_pos,{ align: "right",maxWidth: "7.5" });
      }
      y_pos = y_pos + 0.2
      doc.setLineWidth(0.01).line(0.5, y_pos, 8.0, y_pos);
      y_pos = y_pos + 0.2
      doc.setFontSize(10).text('Sub Total', 6.5, y_pos,{ align: "right",maxWidth: "2" });
      doc.setFontSize(10).text(this.transactions[index].subTotal, 7.5, y_pos,{ align: "right",maxWidth: "7.5" });
      

      if(this.transactions[index].tps > 0){
        y_pos = y_pos + 0.2
        doc.setFontSize(10).text('TPS (5%)', 6.5, y_pos,{ align: "right",maxWidth: "2" });
        doc.setFontSize(10).text(this.transactions[index].tps, 7.5, y_pos,{ align: "right",maxWidth: "7.5" });
        
      }

      if(this.transactions[index].tvq > 0){
        y_pos = y_pos + 0.2
        doc.setFontSize(10).text('TVQ (9.975%)', 6.5, y_pos,{ align: "right",maxWidth: "2" });
        doc.setFontSize(10).text(this.transactions[index].tvq, 7.5, y_pos,{ align: "right",maxWidth: "7.5" });
      }

      for (var m = 0; m < this.transactions[index].taxesList.length; m++) {
        y_pos = y_pos + 0.2
        doc.setFontSize(10).text(this.transactions[index].taxesList[m].Label[this.actualLanguage], 6.5, y_pos,{ align: "right",maxWidth: "4" });
        doc.setFontSize(10).text(this.transactions[index].taxesList[m].Amount, 7.5, y_pos,{ align: "right",maxWidth: "7.5" });       
      }


      y_pos = y_pos + 0.3
      doc.setFontSize(12).text('TOTAL', 6.5, y_pos,{ align: "right",maxWidth: "2" });
      doc.setFontSize(12).text(this.transactions[index].total, 7.5, y_pos,{ align: "right",maxWidth: "7.5" });

      y_pos = y_pos + 1
      doc.setFontSize(12).text(this.InvoicePaidBy[this.actualLanguage], 0.5, y_pos,{ align: "left",maxWidth: "2" });
      y_pos = y_pos + 0.2
      doc.setLineWidth(0.01).line(0.5, y_pos, 8.0, y_pos);
      y_pos = y_pos + 0.2
      doc.setFontSize(10).text(this.transactions[index].cardData.CardType, 0.5, y_pos,{ align: "left",maxWidth: "7.5" });
      y_pos = y_pos + 0.2
      doc.setFontSize(10).text(this.CardInfoLast4[this.actualLanguage]+this.transactions[index].cardData.CardLast4, 0.5, y_pos,{ align: "left",maxWidth: "7.5" });

      doc.setLineWidth(0.01).line(0.5, 10, 8.0, 10);

/*



      // Using array of sentences
      doc
        .setFont("helvetica")
        .setFontSize(12)
        .text(this.moreText, 0.5, 3.5, { align: "left", maxWidth: "7.5" });
      
      // Creating footer and saving file
      doc
        .setFont("times")
        .setFontSize(11)
        .setFontStyle("italic")
        .setTextColor(0, 0, 255)
        .text(
          "This is a simple footer located .5 inches from page bottom",
          0.5,
          doc.internal.pageSize.height - 0.5
        )
        */
      doc.save('Invoice_'+`${this.transactions[index].timestamp}.pdf`);

    },

  
  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
    this.getTransactionHistory()

  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// OrganizationPaymentHistory.vue?551defc9